import { FetchRequestError } from "./FetchRequestError";

/**
 * Classifies a caught value as an unexpected system error (bug or failure
 * that warrants monitoring attention) vs an expected user-facing error
 * (backend-intended product flow, e.g. {@link FetchUserEncodedError},
 * {@link FetchUserError}) that should be suppressed from RUM/Sentry.
 *
 * Non-{@link FetchRequestError} values default to unexpected so genuine
 * JS bugs (TypeError, DOMException, arbitrary thrown values) are surfaced.
 *
 * This function is the single dispatcher for the classification policy,
 * used by {@link reportUnexpectedError} for the console + Sentry channel
 * and by components that report directly to RUM (e.g.
 * `DashboardApiStatusWrapper`) to keep the policy in one place.
 */
export function isUnexpectedSystemError(error: unknown): boolean {
  if (error instanceof FetchRequestError) {
    return error.isUnexpectedSystemError();
  }
  return true;
}
